import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Input from '../../../form/Input'
import TextArea from '../../../form/TextArea'
import Button from '../../../../UniformComponents/Button'
import Typography from '../../../../UniformComponents/Typography'

@observer
class AiSummaries extends Component {
    render() {
        const { props } = this
        const {
            getPrompt, handleSurveyIdBlur, generateSummary, handleCustomPromptOnBlur, customPromptSummary, activeTab,
            generatingPrompt, generatingSummary, promptOutput, generatingCustomSummary, generateSummaryFromCustomPrompt,
            handleClientIdBlur, clientId, surveyId,
        } = props.store

        if (activeTab === 0) {
            return (
                <div style={{ width: '60%', margin: '0 auto', marginTop: 20, display: 'flex', flexDirection: 'column', gap: 20 }}>
                    <div style={{ width: '100%', backgroundColor: 'white', padding: 20, borderRadius: 6 }}>
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                            <Input
                                label="Client ID"
                                type="text"
                                onBlur={handleClientIdBlur}
                            />

                            <Input
                                label="Survey ID"
                                type="text"
                                pattern="/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/gm"
                                placeholder="00000000-0000-0000-0000-000000000000"
                                onBlur={handleSurveyIdBlur}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                            <Button
                                cssClass="regular tertiary"
                                label="Generate prompt"
                                onClick={getPrompt}
                                disabled={generatingPrompt || generatingSummary || !clientId.length || !surveyId.length}
                            />

                            <Button
                                cssClass="regular tertiary"
                                label="Generate summary"
                                onClick={generateSummary}
                                disabled={generatingPrompt || generatingSummary || !clientId.length || !surveyId.length}
                            />
                        </div>
                    </div>

                    {(promptOutput.length || generatingSummary || generatingPrompt) && (
                        <div style={{ width: '100%', backgroundColor: 'white', padding: 20, borderRadius: 6 }}>
                            <Typography>Output</Typography>

                            <div style={{
                                marginTop: 20, padding: 20, border: '1px solid black', borderRadius: 6, minHeight: 100, width: '100%',
                            }}
                            >
                                {generatingPrompt ? 'Generating prompt...' : ''}
                                {generatingSummary ? 'Generating summary...' : ''}
                                {!generatingSummary && !generatingPrompt ? <Typography>{promptOutput}</Typography> : null}
                            </div>
                        </div>
                    )}
                </div>
            )
        }

        return (
            <div style={{ display: 'flex', gap: 20, width: '100%' }}>
                <div style={{ width: '100%' }}>
                    <Button
                        label="Test Prompt"
                        cssClass="regular tertiary"
                        onClick={generateSummaryFromCustomPrompt}
                        disabled={generatingPrompt || generatingCustomSummary}
                    />

                    <br />

                    <br />
                    <TextArea
                        label="Custom Prompt"
                        type="textarea"
                        onBlur={handleCustomPromptOnBlur}
                        defaultValue={promptOutput}
                        textAreaCssStyle={{ height: 400, resize: 'vertical' }}
                    />

                    <br />

                    <Typography>Custom Prompt Output</Typography>

                    <div style={{
                        marginTop: 20, padding: 20, border: '1px solid black', borderRadius: 6, minHeight: 100, width: '100%',
                    }}
                    >
                        {generatingCustomSummary ? 'Generating summary...' : ''}
                        {!generatingCustomSummary ? <Typography>{customPromptSummary}</Typography> : null}
                    </div>
                </div>
            </div>
        )
    }
}

export default AiSummaries
